import {
  createContext,
  type Dispatch,
  type SetStateAction,
  useContext,
} from "react";

import type { FindHotelsOutputData } from "@/types/codegen";

export interface HotelDataContextValue {
  data: FindHotelsOutputData | null;
  setData: Dispatch<SetStateAction<FindHotelsOutputData | null>>;
}

export const HotelDataContext = createContext<HotelDataContextValue | null>(
  null,
);

export const useHotelDataContext = () => {
  const context = useContext(HotelDataContext);
  if (!context) {
    throw new Error(
      "useHotelDataContext must be used within a HotelDataProvider",
    );
  }
  return context;
};
